var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "item" }, [
    _c("div", { staticClass: "form-group form checkox-input item-name" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.itemsSelected,
            expression: "itemsSelected"
          }
        ],
        attrs: {
          id: "result-" + _vm.itemID,
          type: "checkbox",
          autocomplete: "off"
        },
        domProps: {
          value: _vm.result,
          checked: Array.isArray(_vm.itemsSelected)
            ? _vm._i(_vm.itemsSelected, _vm.result) > -1
            : _vm.itemsSelected
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.itemsSelected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = _vm.result,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.itemsSelected = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.itemsSelected = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.itemsSelected = $$c
              }
            },
            function($event) {
              return _vm.selectHandler()
            }
          ]
        }
      }),
      _vm._v(" "),
      _c("label", {
        attrs: { for: "result-" + _vm.itemID },
        domProps: { innerHTML: _vm._s(_vm.result.Title) }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "item-date" }, [
      _vm._v(
        _vm._s(_vm.formatDate(_vm.result.OrderStartDate)) +
          " - " +
          _vm._s(_vm.formatDate(_vm.result.OrderEndDate))
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dafa1d2", { render: render, staticRenderFns: staticRenderFns })
  }
}